<template>
	<div class="page">
		<div class="hero">
			<div class="hero-bg"></div>
			<i class="el-icon-share"></i>
			<h1>推广系统</h1>
			<p class="subtitle">专属推广资源 · 一键生成链接 · 规范合作流程 · 合伙人权益</p>
			<div class="badges">
				<span class="badge">推广链接</span>
				<span class="badge">渠道合作</span>
				<span class="badge">资源对接</span>
				<span class="badge">互利共赢</span>
			</div>
			<ul class="shapes">
				<li></li><li></li><li></li><li></li><li></li>
				<li></li><li></li><li></li><li></li><li></li>
				<li></li><li></li>
			</ul>
			<div class="actions">
				<el-button class="custom-button" @click="open('https://tg.shuhailinghang.cn/')">前往推广系统</el-button>
			</div>
			<ul class="ribbons"><li></li><li></li><li></li></ul>
		</div>
		<div class="section">
			<h2>系统介绍</h2>
			<div class="cards">
				<div class="card intro-card">
					<p>现有会员可通过我们提供的专属推广资源，将数海领航筛查系统、反查系统和外贸系统推荐给朋友与客户。系统支持一键生成推广链接，助力会员构建个人事业网络，通过系统化的合作模式实现代理拓展。对于想拓展兼职渠道的小伙伴，数海领航提供灵活推广合作，按规范流程开拓市场，开拓人脉、积累资源，实现个人与平台共发展。选择成为合伙人或代理商，将解锁更多内部资源：享专属推广策略定制、优先合作对接；厂家让利，共拓市场、整合资源扩业务，实现互利共赢。</p>
				</div>
			</div>
		</div>
		<div class="bottom-section">
			<div class="card feature-grid">
				<div class="feature"><i class="el-icon-link"></i><span>推广链接</span></div>
				<div class="feature"><i class="el-icon-s-custom"></i><span>渠道合作</span></div>
				<div class="feature"><i class="el-icon-s-operation"></i><span>规范流程</span></div>
				<div class="feature"><i class="el-icon-collection"></i><span>资源整合</span></div>
			</div>
		</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Promotion',
	methods: { 
		open(url){ 
			try {
				// 尝试使用 window.open
				const newWindow = window.open(url, '_blank');
				
				// 检查是否被阻止
				if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
					// 如果弹窗被阻止，尝试直接跳转
					window.location.href = url;
				}
			} catch (error) {
				console.error('跳转失败:', error);
				// 如果都失败了，尝试直接跳转
				window.location.href = url;
			}
		} 
	}
}
</script>

<style scoped>
.page { padding: 24px 24px 48px; width: 100%; max-width: none; margin: 0 auto; background: linear-gradient(180deg, #fffaf7 0%, #fff8ef 60%, #fff6ea 100%); border-radius: 12px; min-height: calc(100vh - 48px); display: flex; flex-direction: column; }
.hero { position: relative; overflow: hidden; background: linear-gradient(135deg, #fff1f0 0%, #fffbe6 100%); padding: 40px 24px; border-radius: 12px; text-align: center; }
.hero-bg { position: absolute; inset: -20%; background: radial-gradient(circle at 20% 20%, rgba(255,255,255,0.85), transparent 40%), radial-gradient(circle at 80% 30%, rgba(255,255,255,0.65), transparent 45%), radial-gradient(circle at 40% 80%, rgba(255,255,255,0.55), transparent 50%); filter: blur(8px); }
.hero i { position: relative; z-index: 1; font-size: 56px; color: #fa8c16; animation: pop 2.6s ease-in-out infinite; }
.hero h1 { position: relative; z-index: 1; margin: 28px 0 28px; font-size: 36px; letter-spacing: 0.3px; background: linear-gradient(90deg, #3a2b18, #fa8c16, #3a2b18) !important; -webkit-background-clip: text !important; background-clip: text !important; color: transparent !important; text-shadow: none !important; background-size: 200% 100%; animation: titleShimmer 6s linear infinite; }
.subtitle { position: relative; z-index: 1; color: #3a2b18; margin-bottom: 32px; font-size: 18px; font-weight: 700; line-height: 2.1; padding: 8px 12px; background: rgba(255,255,255,0.7); border-radius: 8px; display: inline-block; }
.badges { position: relative; z-index: 1; display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; margin: 20px 0 32px; }
.badge { background: rgba(250,140,22,0.14); color: #2f2316; padding: 6px 12px; border-radius: 999px; font-size: 13px; font-weight: 700; text-shadow: 0 1px 1px rgba(255,255,255,0.6); }
@keyframes floaty { 0% { transform: translateY(0) rotate(0); } 50% { transform: translateY(-6px) rotate(2deg);} 100% { transform: translateY(0) rotate(0);} }
@keyframes pop { 0%,100% { transform: scale(1);} 50% { transform: scale(1.06);} }
.shapes { position: absolute; inset: 0; margin: 0; padding: 0; list-style: none; pointer-events: none; }
.shapes li { position: absolute; left: 0; top: -20%; width: 28px; height: 28px; background: rgba(250,140,22,0.28); border-radius: 6px; animation: fallDown 12s linear infinite; }
.shapes li:nth-child(1){ left: 6%; width: 36px; height: 36px; animation-duration: 14s; animation-delay: .2s; }
.shapes li:nth-child(2){ left: 24%; width: 48px; height: 48px; animation-duration: 16s; animation-delay: .6s; }
.shapes li:nth-child(3){ left: 36%; width: 30px; height: 30px; animation-duration: 12s; animation-delay: .1s; }
.shapes li:nth-child(4){ left: 58%; width: 42px; height: 42px; animation-duration: 18s; animation-delay: .4s; }
.shapes li:nth-child(5){ left: 74%; width: 28px; height: 28px; animation-duration: 13s; animation-delay: .3s; }
.shapes li:nth-child(6){ left: 88%; width: 60px; height: 60px; animation-duration: 17s; animation-delay: .5s; }
.shapes li:nth-child(7){ left: 16%; width: 26px; height: 26px; animation-duration: 11s; animation-delay: .7s; }
.shapes li:nth-child(8){ left: 46%; width: 40px; height: 40px; animation-duration: 15s; animation-delay: .9s; }
.shapes li:nth-child(9){ left: 66%; width: 34px; height: 34px; animation-duration: 13s; animation-delay: .3s; }
.shapes li:nth-child(10){ left: 82%; width: 46px; height: 46px; animation-duration: 16s; animation-delay: .8s; }
.shapes li:nth-child(11){ left: 28%; width: 24px; height: 24px; animation-duration: 12s; animation-delay: .4s; }
.shapes li:nth-child(12){ left: 48%; width: 52px; height: 52px; animation-duration: 18s; animation-delay: .6s; }
@keyframes fallDown { 0% { transform: translateY(-20vh) rotate(0deg); opacity: .9; } 100% { transform: translateY(120vh) rotate(360deg); opacity: .6; } }
.feature { transition: transform .25s ease, box-shadow .25s ease; }
.feature:hover { transform: translateY(-3px); box-shadow: 0 10px 18px rgba(250,140,22,0.12); }
.feature i { font-size: 18px; margin-right: 6px; }
.actions { position: relative; z-index: 1; margin-top: 28px; display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; }
.section { margin-top: 16px; }
.section h2 { margin: 0 0 32px; }
.cards { display: grid; grid-template-columns: 1fr; gap: 24px; }
.card { background: #ffffff; border: 1px solid #f2e8dc; border-radius: 12px; }
.intro-card { padding: 24px 28px; color: #4a3a27; line-height: 2.0; font-size: 16.5px; }
.intro-card p { max-width: 900px; margin: 0 auto; word-break: break-word; }
.feature-grid { padding: 16px; display: grid; grid-template-columns: repeat(4, minmax(160px, 1fr)); gap: 12px; }
.feature { background: #fff7ed; border: 1px solid #f2e8dc; padding: 12px; border-radius: 10px; display: flex; align-items: center; gap: 8px; justify-content: center; color: #6c4b1b; }
.bottom-section { margin-top: auto; padding-top: 32px; padding-bottom: 24px; }
.feature i { color: #fa8c16; }
.hero { background-size: 200% 200%; animation: gradientShift 14s ease infinite; }
.hero::before { content: ""; position: absolute; inset: 0; background: radial-gradient(600px 300px at 15% 10%, rgba(255,255,255,0.35), transparent 60%), radial-gradient(500px 260px at 85% 20%, rgba(255,255,255,0.25), transparent 60%); pointer-events: none; }
@keyframes gradientShift { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
.shapes li { filter: blur(0.2px); opacity: 0.7; }
.shapes li:nth-child(1){ width: 18px; height: 18px; animation-duration: 5s; animation-delay: .2s; }
.shapes li:nth-child(2){ width: 22px; height: 22px; animation-duration: 6.5s; animation-delay: .6s; }
.shapes li:nth-child(3){ width: 14px; height: 14px; animation-duration: 4.8s; animation-delay: .1s; }
.shapes li:nth-child(4){ width: 28px; height: 28px; animation-duration: 7s; animation-delay: .4s; }
.shapes li:nth-child(5){ width: 16px; height: 16px; animation-duration: 5.6s; animation-delay: .3s; }
/* Badge glow pulse */
.badge { box-shadow: 0 0 0 rgba(250,140,22,0.0); animation: glowPulse 3.2s ease-in-out infinite; }
@keyframes glowPulse { 0%,100% { box-shadow: 0 0 0 rgba(250,140,22,0); } 50% { box-shadow: 0 8px 18px rgba(250,140,22,0.22); } }
.actions .el-button { transition: transform .25s ease, box-shadow .25s ease; }
.actions .el-button:hover { transform: translateY(-2px) scale(1.02); box-shadow: 0 10px 22px rgba(250,140,22,0.18); }

/* Custom button styling */
.actions .custom-button {
	background: #fa8c16;
	border-color: #fa8c16;
	color: white;
}
.actions .custom-button:hover {
	background: #ffa940;
	border-color: #ffa940;
	box-shadow: 0 10px 22px rgba(250,140,22,0.18);
}
/* Feature cards entrance with floaty animation */
.feature { animation: cardIn .5s ease both, floaty 6.5s ease-in-out .6s infinite; }
.feature:nth-child(1){ animation-delay: .05s; }
.feature:nth-child(2){ animation-delay: .12s; }
.feature:nth-child(3){ animation-delay: .19s; }
.feature:nth-child(4){ animation-delay: .26s; }
@keyframes cardIn { from { opacity: 0; transform: translateY(8px);} to { opacity: 1; transform: translateY(0);} }
@keyframes floaty { 0% { transform: translateY(0) rotate(0); } 50% { transform: translateY(-6px) rotate(2deg);} 100% { transform: translateY(0) rotate(0);} }

/* Button breathing */
.actions .el-button { animation: breathe 3.6s ease-in-out .2s infinite; }
@keyframes breathe { 0%,100% { transform: translateY(0) scale(1); } 50% { transform: translateY(-1px) scale(1.03); } }
</style>
<style scoped>
.ribbons { position: absolute; inset: 0; margin: 0; padding: 0; list-style: none; pointer-events: none; z-index: 0; }
.ribbons li { position: absolute; left: -10%; right: -10%; height: 140px; filter: blur(18px); opacity: 0.55; background: linear-gradient(90deg, rgba(250,140,22,0.0), rgba(250,140,22,0.45), rgba(250,140,22,0.0)); animation: sweep 9s ease-in-out infinite; }
.ribbons li:nth-child(1){ top: 10%; }
.ribbons li:nth-child(2){ top: 45%; animation-delay: 1.2s; height: 160px; opacity: 0.6; }
.ribbons li:nth-child(3){ top: 78%; animation-delay: 2.4s; height: 130px; opacity: 0.5; }
@keyframes sweep { 0% { transform: translateX(-10%) rotate(0.5deg);} 50% { transform: translateX(10%) rotate(-0.5deg);} 100% { transform: translateX(-10%) rotate(0.5deg);} }
</style> 